import ApplicationModel, { attr } from '../ApplicationModel';
import { type IntegrationLinkAttributes } from './generated/IntegrationLinkAttributes';
import { model } from '../modelBuilder';

interface IntegrationLink extends IntegrationLinkAttributes {}

@model
class IntegrationLink extends ApplicationModel {
  // Start auto-generated
  static typename: 'IntegrationLink' = 'IntegrationLink';
  get typename(): 'IntegrationLink' {
    return 'IntegrationLink';
  }

  static fields = {
    integrationId: attr({ readable: true }),
    name: attr({ readable: true }),
    url: attr({ readable: true }),
    integration: attr.belongsTo({ readable: true, typename: 'Integration' }),
  };
  // End auto-generated
}

export default IntegrationLink;
